import { Paper, Text, useMantineTheme } from '@mantine/core';

export function InfoCard({
  children,
  label,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <Paper
      radius="md"
      px="04"
      py="02"
      sx={theme => ({ border: `1px solid ${theme.colors.gray[1]}` })}
    >
      {label && (
        <Text variant="sm" fw={400} c="gray.6" truncate>
          {label}
        </Text>
      )}
      {children}
    </Paper>
  );
}

export function InfoCardText({
  children,
  isLlmEnriched,
}: {
  children: React.ReactNode;
  isLlmEnriched?: boolean;
}) {
  const theme = useMantineTheme();

  const aiText = {
    color: 'transparent',
    background: theme.other.gradients.aiHorizontal,
    backgroundClip: 'text',
  };

  return (
    <Text variant="md" fw={400} sx={isLlmEnriched ? aiText : {}} truncate>
      {children}
    </Text>
  );
}
